<template>
    <div class="app-footer">Copyright © 2019-2020 佛山市禅城区砺学培训学校. All Rights Reserved.</div>
</template>

<script>
    export default {
        name: "app-footer"
    }
</script>

<style scoped>
.app-footer{
    text-align: center;
    line-height: 50px;
    height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppFooter.vue